import React, { Component } from 'react';
import { Row, Col, Form, Button, Alert }  from 'react-bootstrap';
import { connect } from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import  { fetchUserWithId, submitUserDetails, submitUserWithIdDetails } from './../actions';
import { getFormValues } from '../../../lib/utils';
import Title from '../../../components/Title';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { addToast } from '../../../components/Toaster';
import UserPageLayout from '../components/UserPageLayout';

import { getUser } from '../selectors';
import { getPathParamIntegerFromProps } from '../../selectors';

export function PasswordRequirements() {
  const { t } = useTranslation();
  return (
    <ul className="my-0">
      <li>{t('user.At_least_1_upper_case_character')}</li>
      <li>{t('user.At_least_1_lower_case_character')}</li>
      <li>{t('user.At_least_1_number_OR_1_special_character')}</li>
      <li>{t('user.At_least_12_total_characters')}</li>
    </ul>
  );
}

class UpdatePassword extends Component {

  state = {
    submit: {},
  };

  // fetch most recent details of the user
  fetchUserDetails = () => {
    const { fetchUserWithId, userToEdit, userToEditId } = this.props;
    fetchUserWithId(userToEdit || { id: userToEditId });
  };

  componentDidMount() {
    this.fetchUserDetails();
  }

  componentDidUpdate(prevProps) {
    // reset submit form if the user is changed
    if (prevProps.userToEditId !== this.props.userToEditId) {
      this.setState({ submit: {} });
      this.fetchUserDetails();
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    const { t } = this.props;
    const form = e.target;
    const { submitUserDetails, submitUserWithIdDetails, userToEdit, userIsSelf } = this.props;
    const { new_password, confirm_password } = getFormValues(e);
    if (new_password !== confirm_password) {
      return addToast({
        variant: 'danger',
        header: this.props.t('user.The_given_passwords_do_not_match'),
      });
    }

    const submittedAt = Date.now();
    this.setState({ submit: { submittedAt } });

    const submitDetails = userIsSelf ? submitUserDetails : submitUserWithIdDetails;

    // submit form then handle feedback
    userToEdit && submitDetails(
      userToEdit,
      { password: new_password },
      { successToast: t('toasts.password-updated') }
    )
      .then(() => {
      // if still displaying the same submission then update with success
        this.setState(({ submit }) => {
          if (submit.submittedAt === submittedAt) {
            // clear the form
            form.reset();
            return { submit: { succeededAt: new Date() } };
          }
        });
      })
      .catch((error) => {
      // if still displaying the same submission then update with failure
        this.setState(({ submit }) => {
          if (submit.submittedAt === submittedAt) {
            return { submit: { error: error.message || 'Error' } };
          }
        });
      });
  };

  render() {
    const { userIsSelf, userToEdit, t } = this.props;
    const { submit } = this.state;
    return (
      <UserPageLayout>
        <Title
          title={userIsSelf
            ? t('user.Update_My_Password')
            : (userToEdit
              ? `${t('user.Updating_User_Password')}: ${userToEdit.name}`
              : ""
            )
          }
          loading={submit.submittedAt}
          lastFetch={submit.succeededAt}
          error={submit.error}
        />
        {!userToEdit ? <LoadingSpinner /> : (
          <Form className="form-container" onSubmit={this.handleSubmit}>
            <Alert variant="info" className="mt-2">
              <p className="my-0">
                {t('user.Use_form_to_change_password')}&nbsp;{t('user.It_must_include')}:
              </p>
              <PasswordRequirements />
            </Alert>
            {!userIsSelf && <Form.Group as={Row}>
              <Form.Label column sm="2" xs="4">
                {t('Email')}
              </Form.Label>
              <Col sm="8" xs="6">
                <Form.Control
                  plaintext
                  readOnly
                  value={ userToEdit.email || "" }
                />
              </Col>
            </Form.Group>}
            <Form.Group as={Row} controlId="form__update_password--new">
              <Form.Label column sm="2" xs="4">
                {t('user.New_Password')}
              </Form.Label>
              <Col sm="8" xs="6">
                <Form.Control
                  type="password"
                  placeholder={t('user.New_Password')}
                  name="new_password"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="form__update_password--confirm">
              <Form.Label column sm="2" xs="4">
                {t('user.Confirm_Password')}
              </Form.Label>
              <Col sm="8" xs="6">
                <Form.Control
                  type="password"
                  placeholder={t('user.New_Password')}
                  name="confirm_password"
                />
              </Col>
            </Form.Group>
            <Form.Group className="text-right mb-chat-widget">
              <Button variant="success" type="submit" size="lg">
                {t('Update')}
              </Button>
            </Form.Group>
          </Form>
        )}
      </UserPageLayout>
    );
  }
}


const mapStateToProps = (state, props) => {
  const user = getUser(state);
  const currentUserId = user && user.id;
  const userToEditId = getPathParamIntegerFromProps(props, 'id') || currentUserId;
  const userIsSelf = userToEditId === currentUserId;
  return {
    userIsSelf,
    userToEditId,
    userToEdit: userIsSelf ? user : getUser(state, userToEditId),
  };
};
const mapDispatchToProps = { fetchUserWithId, submitUserDetails, submitUserWithIdDetails };

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UpdatePassword));
